import styles from './TarifCounsult.module.css'
import InputItem from "../../FormTemplate/InputItem/InputItem";
import {Link} from "react-router-dom";
import WaitLoader from "../../WaitLoader/WaitLoader";
import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {ReduxStateInt} from "../../Reducer/GlobalReducer";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import {AddFeedBackInt} from "../../ClientLK/OrderList/ClientOrderList";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
interface ITarifConsultProps
{
    tarifName: string
    operName: string
    onClose: ()=>void
}
export default function TarifConsult({tarifName,onClose,operName}:ITarifConsultProps)
{

    const addFeedBackData = useRef<AddFeedBackInt>()
    const wrapperRef = useRef<HTMLDivElement>(null);

    const [ldrAddFeedback,rsAddFeedback,exAddFeedback] = useApiQuery("/appeal/add","post",addFeedBackData);
    const appealErrorLine = useRef<ErrorLineItemRef>(null)

    const baseUrl = useSelector((state: ReduxStateInt) => {
        return state.baseUrl
    })
    const [clientNumber, setClientNumber] = useState<{
        correct: boolean
        ctn: string
        text: string
    }>({
        ctn:"",
        correct: false,
        text: ""
    })

    function useOutsideAlerter(ref:any) {
        useEffect(() => {
            /**
             * Alert if clicked on outside of element
             */
            function handleClickOutside(event:any) {
                if (ref.current && !ref.current.contains(event.target)) {
                    //console.log(`You clicked outside of me! ${capt}`);
                    onClose()
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }


    const handleSendAppeal = () =>{
        addFeedBackData.current = {
            type: 6,
            parent: 0,
            author: "Посетитель",
            xData: tarifName,
            yData: clientNumber?.text,
            phone: clientNumber?.text,
            text: `Консультация по тарифу «${tarifName}» от ${operName}`,
            capt:""

        }
        exAddFeedback().then((e)=>{
            if(e?.success)
            {
                if(appealErrorLine.current)appealErrorLine.current.show("Обращение отправлено", false,0)
                setTimeout(()=>onClose(),3000)
                return
            }
            if(appealErrorLine.current)appealErrorLine.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,2000)
        }).catch((e)=>{
            if(appealErrorLine.current)appealErrorLine.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,2000)
        })


    }

    useOutsideAlerter(wrapperRef);

    return(
        <div className={styles.fCont} ref={wrapperRef}>
            <div className={styles.xCont}>
                <div className={styles.conForm}>
                    <div className={styles.formT}><span>[консультация]</span>Ваш телефон</div>
                    <InputItem
                        val={clientNumber.text}
                        mode={"e"}
                        title={""}
                        placeHolder={"XXXXXXXXXX"}
                        titleShift={-4}
                        regExp={/^\+79[0-9]{9}$/ui}
                        maxLen={20}
                        type={"numeric"}
                        onChange={(e)=>{
                            const x = e?.toString()?.replaceAll(/[^0-9+]+/uig,"")
                            if(x.match(/(\+7|8|^)9[0-9]{9}$/ui))
                            {
                                const px = x?.match(/[0-9]{10}$/ui)
                                if(px)
                                {
                                    setClientNumber({
                                        text: `+7${px[0]}`,
                                        correct: true,
                                        ctn: px[0]
                                    })
                                    return
                                }
                            }
                            setClientNumber({
                                text: e,
                                correct: false,
                                ctn: ""

                            })                        }}
                        //                            onIncorrect={(e)=>setCtnBtnState(true)}
                        exitOnEnter={true}



                    />
                    <div className={styles.polText}>Продолжая, Вы соглашаетесь с<Link to={baseUrl+'/static/ppd-politic.docx'} className={styles.polLink}>политикой</Link>использования персональных данных</div>
                    <div className={styles.errCont}>
                        <ErrorLineItem ref={appealErrorLine}></ErrorLineItem>
                    </div>

                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-face "
                                disabled={!clientNumber.correct}
                                onClick={()=>handleSendAppeal()}
                        >запросить</button>
                        <div className={styles.wlCont}>
                            <WaitLoader loading={ldrAddFeedback} api={rsAddFeedback} onlyLoading={true}>

                            </WaitLoader>

                        </div>
                        <button type="button" className="btn btn-face "
                                onClick={()=>onClose()}
                        >передумал</button>


                    </div>

                </div>
            </div>
        </div>
    )
}